// extracted by mini-css-extract-plugin
export var box = "styles-module--box--p_yVH";
export var title = "styles-module--title--3vPSR";
export var button = "styles-module--button--2sLSz";